exports = module.exports = require("../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.footer .vux-slider > .vux-indicator,\n.footer .vux-slider .vux-indicator-right {\n  bottom: 1.25rem !important;\n}\n.footer .vux-icon-dot.active {\n  background: #027cfa !important;\n  width: 0.29rem !important;\n  height: 0.2rem !important;\n  border-radius: 0.1rem !important;\n}\n", ""]);

// exports
